import { io } from "socket.io-client";

const SOCKET_URL = (process.env.REACT_APP_SOCKET_URL || "").replace(/\/+$/, "");
const SOCKET_PATH = process.env.REACT_APP_SOCKET_PATH || "/api/socket.io";

const socket = io(SOCKET_URL || "/", {
  path: SOCKET_PATH,
  transports: ["websocket", "polling"],
  withCredentials: true,
});

export default socket;
